/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlternativeLoginAliases {
  ALTERNATIVE_LOGIN_FETCH = 'alternative-login-fetch',
  ALTERNATIVE_LOGIN_FIELD = 'alternative-login-field',
  ALTERNATIVE_LOGIN_FORM = 'alternative-login-form',
  ALTERNATIVE_LOGIN_INPUT = 'alternative-login-input',
  LAYOUT_ALTERNATIVE_LOGIN = 'layout-alternative-login',
  PANEL_ALTERNATIVE_LOGIN = 'panel-alternative-login',
  REPLACEMENT_LOGIN_FIELD = 'replacement-login-field',
  REPLACEMENT_LOGIN_INPUT = 'replacement-login-input',
}
export { AlternativeLoginAliases };
